import SettingCard from '@/components/SettingCard';
import { Stack } from '@mui/material';
import FaqsSettings from './FaqsSettings';

const FaqsBlockSetttings = () => {
  return (
    <Stack spacing={2}>
      <SettingCard title="Filtros">
        <FaqsSettings />
      </SettingCard>
    </Stack>
  );
};

export default FaqsBlockSetttings;
